<template>
	<div id="app" style="width: 100%;height: 100%;">
		<!-- 统一顶部导航（只在需要的页面显示） -->
		<div class="top-nav" v-if="showTopNav">
			<!-- 左边 LOGO -->
			<div class="logo">
				<span v-if="!(orgLogo && orgLogo.includes('http'))">{{ orgLogo }}</span>
				<img v-else :src="orgLogo" />
			</div>

			<!-- 右边 用户信息 -->
			<div class="user-info">
				<!-- 教师专属二维码图标（修复垂直居中） -->
				<div v-if="userType!=3" class="qr-icon-wrapper" @click="openQrModal">
					<img src="@/ico/stutas/code.svg" style="width:28px;" alt="">
				</div>

				<div style="display: flex;align-items: center;gap: 8px;">
					<span>欢迎：</span>
					<el-dropdown trigger="click" @command="handleDropdown">
						<p type="text" class="user-name-btn">
							<span class="name" style="align-items: center;">{{ loginUser }} </span>
							<i class="el-icon-arrow-down el-icon--right" />
						</p>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="changePwd">修改密码</el-dropdown-item>
							<el-dropdown-item command="changeText" v-if="userType!=3">修改信息</el-dropdown-item>
							<el-dropdown-item command="changePhone"
								v-if="userType!=3">{{isAuthId!=''?'修改手机':'绑定手机'}}</el-dropdown-item>
							<el-dropdown-item command="phonePwd"
								v-if="userType!=3&&isAuthId!=''">修改手机密码</el-dropdown-item>
							<el-dropdown-item command="changeUser" v-if="AuthUserLists.length>1">切换机构</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>

					<el-button type="text" @click="logout" class="logout-btn">退出登录</el-button>
				</div>
			</div>
		</div>

		<!-- 路由出口 + 自动全屏 -->
		<div :class="['router-container', !showTopNav ? 'full-viewport' : '']">
			<router-view />
		</div>

		<Password :show.sync="showPassword" @change-pwd="handleChangePwd" />
		<changeText :show.sync="showChangeText" :userName="loginUser" @success="refreshUserName" />
		<changePhone :show.sync="changePhone" @phonePwd="phonePwd=false" />
		<changeUser :show.sync="changeUser" :AuthUserList="AuthUserList" @success="refreshUserId" />
		<phonePwd :show.sync="phonePwd" @change-pwd="handleChangePwd" />
		<!-- 二维码弹窗 -->
		<el-dialog title="平板端登陆" :visible.sync="qrVisible" width="360px" center>
			<div style="text-align:center;padding:20px 0">
				<img :src="watchQrCode" style="width:220px;height:220px;" alt="平板登录二维码">

				<!-- 过期提示（自动显示） -->
				<p style="color: #F56C6C; margin-top:10px; font-size:14px;" v-if="qrExpired">
					二维码已过期，请点击刷新
				</p>

				<p style="margin-top:10px;color:#999;" v-else>
					二维码三分钟内有效
				</p>

				<!-- 刷新按钮 -->
				<el-button type="primary" icon="el-icon-refresh" style="margin-top:15px;" @click="refreshQrCode">
					刷新二维码
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import Password from './views/components/possword.vue'
	import changeText from './views/components/changeText.vue'
	import changePhone from './views/components/changePhone.vue'
	import changeUser from './views/components/changeUser.vue'
	import phonePwd from './views/components/phonePwd.vue'
	import {
		forGradeList,
		forSubjectList
	} from "@/js/standard.js";
	import {
		getUserClassList
	} from "@/js/userRole.js";
	import QRCode from 'qrcode'

	export default {
		components: {
			Password,
			changeText,
			changePhone,
			changeUser,
			phonePwd
		},
		data() {
			return {
				loginUser: localStorage.getItem('nickName') || '',
				showPassword: false,
				showChangeText: false,
				changePhone: false,
				changeUser: false,
				userType: localStorage.getItem('userType') || 3,
				userId: localStorage.getItem('userId'),
				orgStatus: localStorage.getItem('orgStatus'),
				orgName: localStorage.getItem('orgName'),
				orgLogo: '',
				roleType: localStorage.getItem('roleType'),
				isLogin: false,
				loginText: 'AI智能体互动课堂平台',
				login: null,
				isAuthIdvie: false,
				isAuthId: '',
				AuthUserList: [],
				AuthUserLists: [],
				// 二维码相关
				qrVisible: false,
				// STS缓存
				stsCredential: null,
				stsTimer: null,
				watchQrCode: '',
				phonePwd: false,
				isInitialize: true,
				qrExpired: false, // 是否过期
				qrTimer: null // 倒计时定时器
			}
		},
		computed: {
			showTopNav() {
				const path = this.$route.path;
				const hidePaths = [
					'login',
					'student/class',
					'student/historyClassroom',
					'teacher/interactiveClassroom',
					'teacher/WatchTheClass',
					'teacher/canvasWrap',
					"student/testindex"
				];
				return !hidePaths.some(item => path.includes(item));
			}
		},
		watch: {
			$route: {
				handler() {
					const path = this.$route.path
					if (!path.includes('login')) {
						setTimeout(() => {
							if (localStorage.getItem('token')) {
								if (this.isInitialize) {
									this.startStsAutoRefresh();

								}
								if (localStorage.getItem("userType")) {
									if (localStorage.getItem('orgLogo').includes("/login")) {
										this.loginUrl()
									} else {
										this.orgLogo = localStorage.getItem('orgLogo')
									}

								}
							}
						}, 1000)
					}
					if (path.includes('WatchTheClass')) return
					const fullScreenPaths = ['student/class'];
					if (fullScreenPaths.some(item => path.includes(item))) {
						this.enterFullScreen();
					} else {
						setTimeout(() => {
							this.exitFullScreen();
						}, 0);
					}
					if (!path.includes('login') && !path.includes('teacher/WatchTheClass')) {

					} else {
						this.stopStsAutoRefresh();
					}
					this.userType = localStorage.getItem('userType')
					try {
						if (this.loginUser == '' && localStorage.getItem('nickName')) {
							if (localStorage.getItem('userType') == 2) {
								this.GradeList()
							}
						}

						this.loginUser = localStorage.getItem('nickName') || ''
						this.isAuthId = localStorage.getItem('authId')
						this.isAuthIdvie = !this.isAuthId ? false : this.isAuthId == '' ? false : true
						console.log(this.isAuthId,'this.isAuthIdvie',this.isAuthIdvie)
						if (this.isAuthId && this.AuthUserLists.length == 0) {
							if (localStorage.getItem('userType') == 1 || localStorage.getItem('userType') == 2) {
								this.getAuthList()
							}
						}
					} catch (e) {
						this.loginUser = ''
						this.isAuthId = false
					}
				},
				immediate: true,
				deep: true
			},

		},
		mounted() {},
		beforeDestroy() {
			 this.$bus.$off('refresh-org-logo')
			this.stopStsAutoRefresh();
			if (this.qrTimer) clearTimeout(this.qrTimer)
		},
		created() {
			this.$bus.$on('refresh-org-logo', (val) => {
				// 在这里执行你的逻辑：重新请求logo / 重新获取localStorage / 重新调用接口
				if(val=="phone"){
					this.isAuthId=localStorage.getItem("authId")
					this.isAuthIdvie=true
					this.getAuthList()
				}
				if (localStorage.getItem('orgLogo').includes("/login")) {
					this.loginUrl()
				} else {
					this.orgLogo = localStorage.getItem('orgLogo')
				}
			})
		},
		methods: {
			async loginUrl() {
				this.orgLogo = await this.$oss.getDownloadUrl(localStorage.getItem("orgLogo"))
			},
			// 打开二维码弹窗并生成内容
			async openQrModal() {
				if (localStorage.getItem('userType') != 2) return this.$message.success("只支持教师双端登陆")
				this.qrVisible = true
				this.createQrCode() // 统一生成
			},

			// 生成二维码 + 开始计时
			createQrCode() {
				// 清除旧计时
				if (this.qrTimer) clearTimeout(this.qrTimer)

				this.qrExpired = false
				const token = localStorage.getItem('token')
				const timestamp = Date.now()
				const basePath = process.env.BASE_URL

				// 拼接登录地址
				const url = location.origin + basePath + '#/login' +
					'?type=teacher' +
					'&time=' + timestamp +
					'&token=' + encodeURIComponent(token)

				// 在线二维码
				this.watchQrCode = 'https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=' +
					encodeURIComponent(url)

				// 3 分钟过期
				this.qrTimer = setTimeout(() => {
					this.qrExpired = true
				}, 3 * 60 * 1000)
			},

			// 刷新二维码
			refreshQrCode() {
				this.createQrCode()
			},

			// 原有STS、全屏、业务方法保留不变
			async fetchStsCredential() {
				try {
					const res = await this.API.get(this.API.fileurl.getStsCredential);
					if (res.data.code === 200) {
						this.isInitialize = false
						this.stsCredential = res.data;
						localStorage.setItem('stsCredential', JSON.stringify(res.data))
						window.__GLOBAL_STS_CREDENTIAL__ = res.data;
						return true;
					}
					return false;
				} catch (err) {
					return false;
				}
			},
			startStsAutoRefresh() {
				this.stopStsAutoRefresh();
				// 立即获取一次
				this.fetchStsCredential();
				// 50秒刷新一次（STS 默认有效期 60s）
				this.stsTimer = setInterval(() => {
					this.fetchStsCredential();
				}, 2980 * 1000);
			},
			stopStsAutoRefresh() {
				if (this.stsTimer) clearInterval(this.stsTimer);
				this.stsTimer = null;
			},
			enterFullScreen() {
				let el = document.documentElement;
				if (el.requestFullscreen) el.requestFullscreen();
				else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
				else if (el.mozRequestFullScreen) el.mozRequestFullscreen();
			},
			exitFullScreen() {
				try {
					const fullScreenEl = document.fullscreenElement || document.webkitFullscreenElement || document
						.mozFullScreenElement;
					if (!fullScreenEl) return;
					Promise.resolve().then(() => {
						if (document.exitFullscreen) document.exitFullscreen();
						else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
						else if (document.mozCancelFullScreen) document.mozCancelFullScreen();
					}).catch(() => {});
				} catch (e) {}
			},
			noLogin() {
				if (this.login) {
					this.login.close()
					this.login = null;
				}
			},
			async GradeList() {
				this.gradeList = forGradeList()
				this.loginOpen('任职数据加载中...')
				let t = await getUserClassList(this.API)

				let classList = JSON.stringify(t)

				localStorage.setItem('classList', classList)
				this.noLogin()
			},
			getAuthList() {
				let authId = localStorage.getItem('authId')
				this.API.get(this.API.fileurl.getAuthList + authId, {
					userType: localStorage.getItem('userType')
				}).then(res => {
					this.AuthUserLists = res.data.data
				})
			},
			handleDropdown(command) {
				if (command === 'changePwd') {
					this.showPassword = true
				} else if (command === 'changeText') {
					this.showChangeText = true
				} else if (command === 'changePhone') {
					this.changePhone = true
				} else if (command === 'changeUser') {
					let userId = localStorage.getItem('userId')
					this.AuthUserList = this.AuthUserLists.filter(v => v.id != userId)
					this.changeUser = true
				} else if (command === 'phonePwd') {
					this.phonePwd = true
				}
			},
			handleChangePwd(val) {},
			refreshUserName() {
				this.loginUser = localStorage.getItem('nickName') || ''
				this.GradeList()
			},
			refreshUserId() {
				this.loginUser = localStorage.getItem('nickName') || ''

				const path = this.$route.path
				this.$router.replace('/redirect').then(() => {
					this.$router.replace(path)
					this.GradeList()
				})
			},
			loginOpen(text) {
				this.requestCount = 0
				this.login = this.$loading({
					lock: true,
					text: text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
			},
			async logout() {
				this.loginOpen('退出登陆中...')

				let userType = localStorage.getItem('userType') || 3
				const token = localStorage.getItem('token')
				this.isInitialize = true
				this.API.post(this.API.fileurl.postLogout, {})
					.then(res => {

						if (res.data.code === 200) {
							this.$message.success('退出成功')
							localStorage.clear()
							this.login.close()
							this.pushLoginPage(userType)
						}
					})
					.catch(() => {
						this.login.close()
						localStorage.clear()
						this.pushLoginPage(userType)
					})
			},
			pushLoginPage(userType) {
				if (userType == 1) {
					this.$router.push('/admin/login')
				} else if (userType == 2) {
					this.$router.push('/login?type=teacher')
				} else if (userType == 3) {
					this.$router.push('/login?type=student')
				} else {
					this.$router.push('/login?type=student')
				}
			}
		}
	}
</script>

<style>
	html,
	body,
	#app {
		margin: 0;
		padding: 0;
		width: 100%;
		height: 100%;
		overflow: hidden;
		min-width: unset;
		box-sizing: border-box;
	}

	.top-nav {
		height: 50px;
		min-height: 50px;
		max-height: 50px;
		background: #1e88e5;
		color: #fff;
		padding: 0 15px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: nowrap;
		box-sizing: border-box;
	}

	.logo {
		font-size: 18px;
		font-weight: bold;
		white-space: nowrap;
		display: flex;
		align-items: center;
	}

	.logo img {
		max-height: 32px;
		object-fit: contain;
	}

	.user-info {
		display: flex;
		align-items: center;
		gap: 12px;
		white-space: nowrap;
	}

	/* 修复二维码图标垂直居中 */
	.qr-icon-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: white;
		cursor: pointer;
		height: 100%;
	}

	.user-name-btn {
		color: white !important;
		cursor: pointer;
		padding: 0 8px;
	}

	.name {
		display: inline-block;
		max-width: 3em;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		vertical-align: middle;
	}

	.logout-btn {
		display: inline-flex !important;
		align-items: center !important;
		justify-content: center !important;
		height: 28px !important;
		color: #2f4050 !important;
		background: white !important;
		border-radius: 4px !important;
		padding: 0 10px !important;
		border: none !important;
		white-space: nowrap;
	}

	@media (max-width: 768px) {
		.top-nav {
			height: 50px !important;
			min-height: 50px !important;
			max-height: 50px !important;
			padding: 0 12px;
		}

		.logo {
			font-size: 16px;
		}
	}

	@media (max-width: 480px) {
		.top-nav {
			height: 50px !important;
			min-height: 50px !important;
			max-height: 50px !important;
			flex-direction: row !important;
			justify-content: space-between;
			align-items: center;
			padding: 0 10px;
		}

		.logo {
			font-size: 15px;
		}

		.user-info {
			justify-content: flex-end;
		}

		.logout-btn {
			padding: 0 8px !important;
			font-size: 12px !important;
		}
	}

	@media (max-width: 320px) {
		.logo {
			font-size: 14px;
		}

		.user-info span {
			display: none;
		}
	}

	.el-loading-mask {
		z-index: 9999 !important;
		background-color: rgba(255, 255, 255, 0.7) !important;
	}

	.el-loading-spinner {
		z-index: 10000 !important;
	}

	.router-container {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.router-container.full-viewport {
		height: 100vh !important;
		width: 100vw !important;
		position: relative;
		overflow: hidden !important;
	}
</style>